import * as ReactDOM from 'react-dom';
import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import App from './App';
import 'overlayscrollbars/overlayscrollbars.css';
import { MsalProvider } from '@azure/msal-react';

const msalConfig = {
  auth: {
    clientId: __CLIENT_ID__,
    authority: `https://login.microsoftonline.com/${__TENANT_ID__}`,
    redirectUri: `${window.location.origin}`,
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

const BUILD_VERSION_KEY = 'app_build_version';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance
  .initialize()
  .then(() => {
    return msalInstance.handleRedirectPromise();
  })
  .then((result) => {
    // Clear stale MSAL cache AFTER handling any pending redirect to avoid
    // wiping interaction state mid-flow (which causes interaction_in_progress loops).
    const previousVersion = localStorage.getItem(BUILD_VERSION_KEY);
    if (previousVersion && previousVersion !== __BUILD_VERSION__ && !result) {
      Object.keys(localStorage).forEach((key) => {
        if (
          key.startsWith('msal.') ||
          key.includes('accesstoken') ||
          key.includes('idtoken') ||
          key.includes('refreshtoken')
        ) {
          localStorage.removeItem(key);
        }
      });
    }
    localStorage.setItem(BUILD_VERSION_KEY, __BUILD_VERSION__);

    if (result && result.account) {
      msalInstance.setActiveAccount(result.account);
    }
    ReactDOM.render(
      <BrowserRouter>
        <MsalProvider instance={msalInstance}>
          <App instance={msalInstance} />
        </MsalProvider>
      </BrowserRouter>,
      document.getElementById('root')
    );
  })
  .catch((error) => {
    console.error('Error during MSAL initialization or redirect handling:', error);
    ReactDOM.render(
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <h1>Something went wrong</h1>
        <p>Unable to initialize the application. Please try again later.</p>
      </div>,
      document.getElementById('root')
    );
  });
